import React from "react";
import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";

interface RichTextEditorProps {
  content: string;
  setContent: (content: string) => void;
  label?: string;
  className?: string;
  placeholder?: string;
}

export default function RichTextEditor({
  content,
  setContent,
  label = "İçerik",
  className = "min-h-[200px]",
  placeholder = "Lütfen içeriği buraya girin..."
}: RichTextEditorProps) {
  const modules = {
    toolbar: [
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      ["bold", "italic", "underline", "strike"],
      [{ list: "ordered" }, { list: "bullet" }],
      [{ color: [] }, { background: [] }],
      ["link"],
      ["clean"],
    ],
    clipboard: {
      matchVisual: false,
    },
  };

  return (
    <div className="space-y-2">
      {label && <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">{label}</label>}
      <ReactQuill
        theme="snow"
        value={content}
        onChange={setContent}
        modules={modules}
        className={className} 
        placeholder={placeholder}
      />
    </div>
  );
}
